/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Tc_Infos_AltInputs */

const fr_vehicle_details_tc_infos_alt = /** @type {(inputs: Vehicle_Details_Tc_Infos_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir sur TC-Infos`)
};

const en_vehicle_details_tc_infos_alt = /** @type {(inputs: Vehicle_Details_Tc_Infos_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View on TC-Infos`)
};

/**
* | output |
* | --- |
* | "View on TC-Infos" |
*
* @param {Vehicle_Details_Tc_Infos_AltInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_tc_infos_alt = /** @type {((inputs?: Vehicle_Details_Tc_Infos_AltInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Tc_Infos_AltInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_tc_infos_alt(inputs)
	return en_vehicle_details_tc_infos_alt(inputs)
});